<template>
    <tr>
        <td>
            <span v-if="edit">
                <v-select
                    :options="busCompanies"
                    label="name"
                    :reduce="(company) => company.id"
                    v-model="form.bus_company_id"
                    class="border"
                    style=""
                >
                </v-select>
            </span>
            <span v-else>
                {{ row.company.name }} <span style="color: grey; font-size: 10px;">(id: {{ row.company.id }})</span>
            </span>
        </td>
        <td>{{ row.id }}</td>
        <td>
            <span v-if="edit">
                <v-select
                    :options="busFareTypes"
                    label="name"
                    :reduce="(fareType) => fareType.id"
                    v-model="form.bus_fare_id"
                    class="border"
                    style=""
                >
                </v-select>
            </span>
            <span v-else>
                {{ row.fare_type.name }} <span style="color: grey; font-size: 10px;">(id: {{ row.fare_type.id }})</span>
            </span>
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="number"
                    v-model="form.number_seats_bottom_range"
                    placeholder="Asientos desde"
                    class="border"
                    style="width: 120px;"
                >
                </b-form-input>
            </span>
            <span v-else>
                {{ row.number_seats_bottom_range }}
            </span>
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="number"
                    v-model="form.number_seats_top_range"
                    placeholder="Asientos hasta"
                    class="border"
                    style="width: 120px;"
                >
                </b-form-input>
            </span>
            <span v-else>
                {{ row.number_seats_top_range }}
            </span>
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="number"
                    step="0.01"
                    v-model="form.price"
                    placeholder="Precio"
                    class="border"
                    style="width: 120px;"
                >
                </b-form-input>
            </span>
            <span v-else>
                {{ transformed_price }}
            </span>
        </td>
        <td>{{ this.$moment(row.created).format("DD/MM/YYYY HH:MM") }}</td>
        <td>{{ this.$moment(row.updated).format("DD/MM/YYYY HH:MM") }}</td>
        <td>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="editRow"
                v-if="!edit"
            >
                <i class="text-center fa fa-wrench fa-fw"></i>
                Editar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="saveChanges"
                v-if="edit"
            >
                <i class="text-center fa fa-save fa-fw"></i>
                Guardar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="deleteRow"
            >
                <i class="text-center fa fa-trash fa-fw"></i>
                Eliminar
            </b-button>
        </td>
    </tr>
</template>


<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
export default {
    componenents: {},
    props: {
        row: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            edit: false,
            form: {
                bus_company_id: this.row.company != null ? this.row.company.id : null,
                bus_fare_id: this.row.fare_type != null ? this.row.fare_type.id : null,
                number_seats_bottom_range: this.row.number_seats_bottom_range,
                number_seats_top_range: this.row.number_seats_top_range,
                price: this.row.price
            }
        }
    },
    methods: {
        async editRow()  {
            this.edit = true
            
        },
        async saveChanges() {
            const data = {
                item_id: this.row.id,
                payload: {
                    ...this.form
                }
            }
            await this.$store.dispatch('buscompaniesprices/updateBusCompanyPrice', data)
            .then( () => {
                this.$notify({
                    group: "foo",
                    title: "Precio editado",
                    text: "Se ha editado la información referente al precio",
                    type: "success",
                });
                this.edit = false
            })
            .catch( () => {})
        },
        async deleteRow() {
            const data = {
                item_id: this.row.id,
            }
            this.$store.dispatch('buscompaniesprices/deleteBusCompanyPrice', data)
            .then( response => {
                this.$store.dispatch('buscompaniesprices/retrieveBusCompaniesPrices')
                this.$notify({
                    group: "foo",
                    title: "El precio se ha eliminado",
                    text: "El precio se ha eliminado satisfactoriamente",
                    type: "success",
                });
            })
            .catch( error => {
                this.$notify({
                    group: "foo",
                    title: "El precio no se puede eliminar",
                    text: "El precio (" + this.row.company.name + " - " + this.row.number_seats_bottom_range + "-" + this.row.number_seats_top_range + ") no se puede eliminar",
                    type: "error",
                });
            })
        }
    },
    computed: {
        ...mapGetters(["busCompanies", "busFareTypes"]),
        transformed_price() {
            if ( this.row.price.includes('.') ) {
                return this.row.price.replace('.', ',') + " €"
            }
            return this.row.price
        }
    }
}
</script>
